export default {"src":"/_next/static/media/checkmark-square-none-white.12eb74fe.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};